export const WEEKDAYS = [
  { value: 'mo', label: 'Montag' },
  { value: 'di', label: 'Dienstag' },
  { value: 'mi', label: 'Mittwoch' },
  { value: 'do', label: 'Donnerstag' },
  { value: 'fr', label: 'Freitag' },
  { value: 'sa', label: 'Samstag' },
  { value: 'so', label: 'Sonntag' },
];

const TIME_RE = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export function formatAvailabilityWindow(window) {
  const day = WEEKDAYS.find((d) => d.value === window?.weekday)?.label;
  const from = String(window?.from || '').slice(0, 5);
  const to = String(window?.to || '').slice(0, 5);
  if (!day || !TIME_RE.test(from)) return '';
  if (TIME_RE.test(to)) {
    if (to <= from) return '';
    return `${day} ${from}–${to} Uhr`;
  }
  return `${day} ab ${from} Uhr`;
}

export function formatAvailability(windows) {
  return (windows || []).map(formatAvailabilityWindow).filter(Boolean).join(', ');
}

export function availabilityReady(windows) {
  const touched = (windows || []).filter((w) => w.weekday || w.from || w.to);
  if (!touched.length) return false;
  return touched.every((w) => formatAvailabilityWindow(w));
}
